import React from 'react'

const VoucherIcon = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0025 11.6352L10.0029 13.0637L11.0029 13.0635L11.0025 11.6349L10.0025 11.6352Z"
        fill="#5D7290"
      />
      <path
        d="M10.0032 14.4923L10.0035 15.9209L11.0035 15.9206L11.0032 14.4921L10.0032 14.4923Z"
        fill="#5D7290"
      />
      <path
        d="M10.0039 17.3494L10.0042 18.778L11.0042 18.7778L11.0039 17.3492L10.0039 17.3494Z"
        fill="#5D7290"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00303 13.7612C3.70882 13.5911 3.36726 13.4938 3.00297 13.4939L3.00229 10.4939C3.00204 9.38933 3.89726 8.49369 5.00183 8.49344L25.0018 8.48888C26.1064 8.48863 27.002 9.38385 27.0023 10.4884L27.003 13.4884C26.6387 13.4885 26.2972 13.586 26.003 13.7562C25.4053 14.1022 25.0033 14.7486 25.0034 15.4889C25.0036 16.2292 25.4059 16.8754 26.0038 17.2211C26.298 17.3912 26.6396 17.4885 27.0039 17.4884L27.0046 20.4884C27.0048 21.593 26.1096 22.4886 25.005 22.4889L5.00502 22.4934C3.90046 22.4937 3.00482 21.5985 3.00457 20.4939L3.00388 17.4939C3.36817 17.4938 3.70969 17.3963 4.00382 17.2261C4.60155 16.8802 5.0036 16.2337 5.00343 15.4934C5.00326 14.7532 4.60091 14.1069 4.00303 13.7612ZM11.0021 9.49207L25.0021 9.48888C25.5543 9.48875 26.0022 9.93636 26.0023 10.4886L26.0028 12.6594C24.8377 13.0715 24.0031 14.1829 24.0034 15.4891C24.0037 16.7953 24.8388 17.9064 26.0041 18.3179L26.0046 20.4886C26.0047 21.0409 25.5571 21.4888 25.0048 21.4889L11.0048 21.4921L11.0045 20.2064L10.0045 20.2066L10.0048 21.4923L5.0048 21.4934C4.45251 21.4936 4.00469 21.046 4.00457 20.4937L4.00407 18.323C5.16917 17.9109 6.00373 16.7994 6.00343 15.4932C6.00313 14.187 5.16807 13.0759 4.00278 12.6644L4.00229 10.4937C4.00216 9.94138 4.44977 9.49357 5.00206 9.49344L10.0021 9.4923L10.0022 10.2066L11.0022 10.2064L11.0021 9.49207Z"
        fill="#5D7290"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6233 11.8392C20.8934 12.032 20.9561 12.4073 20.7632 12.6774L16.142 19.1503C15.9492 19.4204 15.5739 19.483 15.3037 19.2902C15.0336 19.0973 14.971 18.722 15.1638 18.4519L19.785 11.9791C19.9779 11.709 20.3532 11.6463 20.6233 11.8392Z"
        fill="#5D7290"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0029 13.0941C14.0027 12.2657 14.6741 11.5939 15.5025 11.5937C16.331 11.5935 17.0027 12.265 17.0029 13.0934L17.0031 14.0934C17.0033 14.9218 16.3319 15.5935 15.5035 15.5937C14.675 15.5939 14.0033 14.9225 14.0031 14.0941L14.0029 13.0941ZM15.5028 12.5937C15.2266 12.5938 15.0028 12.8177 15.0029 13.0939L15.0031 14.0939C15.0032 14.37 15.2271 14.5938 15.5032 14.5937C15.7794 14.5937 16.0032 14.3698 16.0031 14.0936L16.0029 13.0936C16.0028 12.8175 15.7789 12.5937 15.5028 12.5937Z"
        fill="#5D7290"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0038 17.0929C19.0036 16.2645 19.675 15.5928 20.5035 15.5926C21.3319 15.5924 22.0036 16.2638 22.0038 17.0923L22.004 18.0923C22.0042 18.9207 21.3328 19.5924 20.5044 19.5926C19.6759 19.5928 19.0042 18.9214 19.004 18.0929L19.0038 17.0929ZM20.5037 16.5926C20.2275 16.5927 20.0037 16.8166 20.0038 17.0927L20.004 18.0927C20.0041 18.3689 20.228 18.5927 20.5041 18.5926C20.7803 18.5925 21.0041 18.3686 21.004 18.0925L21.0038 17.0925C21.0037 16.8163 20.7798 16.5925 20.5037 16.5926Z"
        fill="#5D7290"
      />
    </svg>
  )
}

export default React.memo(VoucherIcon)
